import { StoreSlice } from '../types';

export declare type INullableString = string | null;

export declare interface IGlobalPlayPauseSeekSlice {
  play: boolean,
  isPlaying: boolean;
  isPauseEnabled: boolean;
  isPauseMenuDisplayed: boolean;
  isPauseBtnDisplayed: boolean;
  isInterrupterModalDisplayed: boolean;
  showSkip: boolean;
  skipTarget: INullableString;
  backTarget: INullableString;
  setPlay: (v: boolean) => void,
  setIsPlaying: (v: boolean) => void;
  setIsPauseEnabled: (v: boolean) => void;
  setIsPauseMenuDisplayed: (v: boolean) => void;
  setIsPauseBtnDisplayed: (v: boolean) => void;
  setIsInterrupterModalDisplayed: (v: boolean) => void;
  setShowSkip: (v: boolean) => void;
  setSkipTarget: (v: INullableString) => void;
  setBackTarget: (v: INullableString) => any;
  showGameBoard: boolean;
  setShowGameBoard: (v: boolean) => void;
}

const createGlobalPlayPauseSeekSlice: StoreSlice<IGlobalPlayPauseSeekSlice> = (set) => ({
  play: false,
  isPlaying: true,
  isPauseEnabled: false,
  isPauseMenuDisplayed: false,
  isPauseBtnDisplayed: false,
  isInterrupterModalDisplayed: false,
  showSkip: false,
  skipTarget: null,
  backTarget: null,
  // play
  setPlay: (v) => set((state) => { state.play = v; }),
  setIsPlaying: (v: boolean) => set((state) => { state.isPlaying = v; }),
  // pause
  setIsPauseEnabled: (v) => set((state) => { state.isPauseEnabled = v; }),
  setIsPauseMenuDisplayed: (v) => set((state) => { state.isPauseMenuDisplayed = v; }),
  setIsPauseBtnDisplayed: (v) => set((state) => { state.isPauseBtnDisplayed = v; }),
  // interrupter model
  setIsInterrupterModalDisplayed: (v) => set((state) => { state.isInterrupterModalDisplayed = v; }),
  // buttons
  setShowSkip: (v) => set((state) => { state.showSkip = v; }),
  setSkipTarget: (v) => set((state) => {
    state.showSkip = !!v;
    state.skipTarget = v;
  }),
  setBackTarget: (v) => set((state) => { state.backTarget = v; }),
  showGameBoard: true,
  setShowGameBoard: (v) => set((state) => { state.showGameBoard = v; }),
});

export default createGlobalPlayPauseSeekSlice;
